/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-03-25 14:29:15
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-03-03 09:45:43
 * @FilePath: \lightning\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
// import App from './App.vue';

// https://www.moodsci.com/SWDataservice/interface/v1/api
// http://10.228.202.140:8080/SWDataservice/interface/v1/api
// import * as L from 'leaflet'
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet/dist/leaflet.css'
Vue.config.productionTip = false
axios.defaults.withCredentials = true

// 请求拦截器：除了登录本身，其余都加 token
axios.interceptors.request.use(config => {
  // 登录接口不加
  if (!config.url.includes('/login')) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Token =  token
    }
  }
  return config
}, error => Promise.reject(error))

// 响应拦截器：登录成功把 token 存起来
axios.interceptors.response.use(res => {
  // 后端把 token 放在 data 里（按你们约定改）
  console.log(res);
  try {
    if (res.data && res.data.code !== 500) {
      if (res.data.data && res.data.data.token) {
        localStorage.setItem('token', res.data.data.token)
      }
    }
  } catch (e) {
    console.error('保存token失败:', e)
  }
  return res
}, error => {
  console.error('响应错误:', error)
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

Vue.prototype.$url = 'https://www.moodsci.com/SWDataservice/interface/v1/api'
Vue.prototype.$url2 = 'https://www.moodsci.com/xjthunder'
// Vue.prototype.$url2 = 'http://120.79.183.250:9001'
// Vue.prototype.$url = 'https://www.moodsci.com/SWDataservice/interface/v1/api'
// Vue.prototype.$url = '/api/SWDataservice/interface/v1/api'
// Vue.prototype.$url = 'http://10.228.202.140:8080/SWDataservice/interface/v1/api'
// Vue.prototype.$sendurl = 'http://120.79.183.250:3098'
// Vue.prototype.$sendurl = 'http://10.228.202.140:3099'
// axios.defaults.baseURL ='https://www.moodsci.com/';
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
